export enum CohortModalities {
    Individual = "individual",
    Group = "group",
    NoCoach = "no_coach"
}

export type LikertColorType = "blank" | "gray" | "colored" | "brand" | "blank-2"

export interface ColorRange {
    from_option: number
    to_option: number
    uuid: string
    color: string
}
